import { axiosInstance } from './instance'

const getProcess = (storeId) => {
    return axiosInstance.get(`stores/${storeId}/progress`)
}

const sendResponsePopup = (storeId, data) => {
    return axiosInstance.post(`stores/${storeId}/surveys`, data)
}

export { getProcess, sendResponsePopup };